import { personalInfo } from "@/mocks/devData";

export default function DevFooter() {
  return (
    <footer
      className="relative py-10 overflow-hidden"
      style={{ background: "#080808", borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="absolute top-0 left-0 right-0 h-[1px]" style={{ background: "linear-gradient(90deg, transparent, rgba(34,197,94,0.3), transparent)" }} />

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="text-xl tracking-tight" style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700 }}>
            <span className="text-white">HR </span>
            <span style={{ color: "#86efac", opacity: 0.8 }}>Safin</span>
          </div>

          {/* Copyright */}
          <p className="text-gray-600 text-xs font-mono text-center">
            &copy; {new Date().getFullYear()}{" "}
            <span className="text-green-400/70 font-semibold">{personalInfo.name}</span>{" "}
            — All Rights Reserved.
          </p>

          {/* Socials */}
          <div className="flex items-center gap-2">
            {[
              { icon: "ri-linkedin-box-fill", href: personalInfo.linkedin },
              { icon: "ri-github-fill", href: personalInfo.github },
              { icon: "ri-mail-fill", href: `mailto:${personalInfo.email}` },
            ].map((s) => (
              <a
                key={s.icon}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-500 hover:text-green-400 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer"
                style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)" }}
              >
                <i className={`${s.icon} text-sm`} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}